import React, { Component } from 'react';
import { ListGroup, ListGroupItem, CustomInput, Collapse } from 'reactstrap';

import InputRange from 'react-input-range';

class Checkbox extends Component {
  constructor(props){
    super(props);
    this.state = {
      checked: true
    }
  }
  toggle = () => {
    this.setState({
      checked: !this.state.checked
    });
  }
  render(){
    return (
      <CustomInput
        type="checkbox"
        label={ this.props.name }
        id={ this.props.name }
        checked={ this.state.checked }
        onClick={ this.toggle }
      />
    );
  }
}

export class CheckFilter extends Component {
  constructor(props){
    super(props);
    this.state = {
      collapse: (this.props.isOpen || false)
    }
  }
  render(){
    return (
      <React.Fragment>
        <ListGroupItem className="text-left d-flex justify-content-between border-0 action" onClick={() => this.setState({collapse: !this.state.collapse})}>
          <h6>{ this.props.name }</h6><i className={this.state.collapse ? 'fas fa-chevron-up' : 'fas fa-chevron-down'}></i>
        </ListGroupItem>
        <Collapse isOpen={this.state.collapse}>
          { this.props.items.map(typ =>
            <ListGroupItem className="text-left border-0 py-1">
              <Checkbox name={typ} />
            </ListGroupItem>
          ) }
          <ListGroupItem className="text-left border-0 py-2"></ListGroupItem>
        </Collapse>
      </React.Fragment>
    );
  }
}

export class RangeFilter extends Component {
  constructor(props){
    super(props);
    this.state = {
      value: {
        min: this.props.min,
        max: this.props.max
      },
    }
  }
  render(){
    return (
      <React.Fragment>
        <ListGroupItem className="text-left d-flex justify-content-between border-0 filterHeadline">
          <h6>{this.props.name}</h6>
        </ListGroupItem>
        <ListGroupItem className="text-left border-0 pt-0 pb-4">
          <h6 className="text-secondary mb-2">{this.state.value.min}–{this.state.value.max}</h6>
          <InputRange
            maxValue={this.props.max}
            minValue={this.props.min}
            value={this.state.value}
            onChange={value => this.setState({ value: value })} />
        </ListGroupItem>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui-elements/Filter.js